// 📁 src/components/InternshipInsights.jsx
import React, { useEffect } from "react";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import { FaBriefcase } from "react-icons/fa";
import AOS from "aos";
import "aos/dist/aos.css";
import "../AboutCard.css"; // ✅ reuse same CSS for styling consistency

function Acc() {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    
    <div className="about-timeline" data-aos="fade-up">
      <h2 className="timeline-heading">Internship Insights</h2>

      <VerticalTimeline lineColor="#3b82f6">
        {/* Sysquare Technologies */}
        <VerticalTimelineElement
          className="vertical-timeline-element--work"
          contentStyle={{
            background: "transparent",
            border: "none",
            boxShadow: "none",
            padding: "0",
          }}
          contentArrowStyle={{ borderRight: "7px solid #3b82f6" }}
          date="2024"
          iconStyle={{ background: "#3b82f6", color: "#fff" }}
          icon={<FaBriefcase />}
        >
          <div className="internship-card">
            <h3 className="vertical-timeline-element-title">
              Sysquare Technologies
            </h3>
            <h4 className="vertical-timeline-element-subtitle">
              Frontend Developer Intern
            </h4>

            <div className="hover-details">
              <p>
                Mastered modern JavaScript, jQuery, and React.js while exploring
                Git, SQL operations, and API integration using Postman.
              </p>

              <div className="hidden-content">
                <p>🚀 <strong>Key Learnings:</strong></p>
                <ul>
                  <li>Developed responsive UI components with React.</li>
                  <li>Integrated REST APIs using Axios and Postman.</li>
                  <li>Collaborated with Git for version control.</li>
                </ul>
              </div>
            </div>
          </div>
        </VerticalTimelineElement>

        {/* Celebal Technologies */}
        <VerticalTimelineElement
          className="vertical-timeline-element--work"
          contentStyle={{
            background: "transparent",
            border: "none",
            boxShadow: "none",
            padding: "0",
          }}
          contentArrowStyle={{ borderRight: "7px solid #3b82f6" }}
          date="2023"
          iconStyle={{ background: "#3b82f6", color: "#fff" }}
          icon={<FaBriefcase />}
        >
          <div className="internship-card">
            <h3 className="vertical-timeline-element-title">
              Celebal Technologies
            </h3>
            <h4 className="vertical-timeline-element-subtitle">
              Frontend Developer Intern
            </h4>

            <div className="hover-details">
              <p>
                Mastered modern React.js while exploring Git, Microsoft Azure,
                and cloud deployment.
              </p>

              <div className="hidden-content">
                <p>🌟 <strong>Key Learnings:</strong></p>
                <ul>
                  <li>Built reusable React components and hooks.</li>
                  <li>Deployed web apps using Azure static web apps.</li>
                  <li>Worked in agile sprints with daily standups.</li>
                </ul>
              </div>
            </div>
          </div>
        </VerticalTimelineElement>
      </VerticalTimeline>
    </div>
  );
}

export default Acc;
